import React from 'react';
import { motion } from 'framer-motion';
import {
  SiAmazonaws,
  SiAwslambda,
  SiAmazonapigateway,
  SiAmazondynamodb,
  SiTerraform,
  SiDocker,
  SiGithubactions,
  SiLinux,
  SiGrafana,
  SiPrometheus,
  SiPython,
  SiPowershell,
  SiPostgresql,
  SiMysql,
  SiKubernetes,
  SiGnubash
} from 'react-icons/si';
import { FaHammer,FaHardHat  } from "react-icons/fa";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { GiGloves } from "react-icons/gi";

const icons = [
  FaHardHat,
  GiGloves,
  FaScrewdriverWrench,
  FaHammer,
  SiAmazonaws,
  SiAwslambda,
  SiAmazonapigateway,
  SiAmazondynamodb,
  SiTerraform,
  SiDocker,
  SiGithubactions,
  SiLinux,
  SiGrafana,
  SiPrometheus,
  SiPython,
  SiPowershell,
  SiPostgresql,
  SiMysql,
  SiKubernetes,
  SiGnubash
];

// Total number of floating icons to render
const TOTAL_ICONS = 80;

const getRandomStyle = () => ({
  top: `${Math.random() * 100}vh`,
  left: `${Math.random() * 100}vw`,
  fontSize: `${24 + Math.random() * 10}px`,
  opacity: 0.06 + Math.random() * 0.1
});

const FloatingIconsBackground = () => {
  const iconInstances = Array.from({ length: TOTAL_ICONS }, (_, i) => {
    const Icon = icons[Math.floor(Math.random() * icons.length)];
    const style = getRandomStyle();
    const duration = 10 + Math.random() * 20;
    const delay = Math.random() * 5;

    return (
      <motion.div
        key={i}
        className="absolute text-white pointer-events-none"
        style={style}
        initial={{ y: 0 }}
        animate={{
          y: [0, -20, 0],
          x: [0, 20, -10, 0],
          rotate: [0, 10, -5, 0]
        }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          duration,
          delay
        }}
      >
        <Icon />
      </motion.div>
    );
  });

  return (
    <div className="fixed inset-0 z-0 overflow-hidden">
      {iconInstances}
    </div>
  );
};

export default FloatingIconsBackground;
